import useSWR, { SWRResponse } from 'swr';
import { Invoice } from '../../../providers/api/dtos';
import { getInvoice } from '../../../providers/api/invoice/invoiceProvider';

export const getUseInvoiceRid = (id: number) => ['/api/v4/invoices', 'invoice', id];

export default function useInvoice(id?: number): SWRResponse<Invoice> {
  const key = id ? getUseInvoiceRid(id) : null;

  return useSWR(key, () => getInvoice(id!));
}
